import Viola81 from '../../../../src/media/SCG/Viola/8/Viola 8.webp'
import Viola82 from '../../../../src/media/SCG/Viola/8/8 Deluxxe.png'
import Viola83 from '../../../../src/media/SCG/Viola/8/8 Premium.png'
import Viola84 from '../../../../src/media/SCG/Viola/8/8 attic.png'

const Viola8images =[
Viola81,Viola82,Viola83,Viola84
]

export default Viola8images;